import React, { useEffect, useState } from "react";
import { Box, Typography, Card, CardContent, CardMedia, Button, CircularProgress } from "@mui/material";
import ApiService from "../../services/api-service";

export default function Livestream() {
  const [streams, setStreams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [addCount, setAddCount] = useState("");
  const [addingStreamId, setAddingStreamId] = useState(null);

 useEffect(() => {
  const fetchStreams = async () => {
    setLoading(true);
    try {
      const resp = await ApiService.LIVESTREAM();
      console.log("Fetched streams:", resp.result); // <-- LOG
      setStreams(resp.result || []);
    } catch (e) {
      setStreams([]);
    }
    setLoading(false);
  };
  fetchStreams();
}, []);

  const handleJoin = (stream) => {
    window.open(stream.url || "#", "_blank");
  };

  const handleEnd = async (channelName) => {
    try {
      await ApiService.ADMIN_END_LIVESTREAM({ channelName });
      setStreams((prev) => prev.filter((s) => s.channelName !== channelName));
    } catch (e) {
      alert("Failed to end stream.");
    }
  };

const handleAddUsers = async (stream) => {
  console.log("Stream object:", stream); // <-- Add this
  if (!addCount || isNaN(addCount) || Number(addCount) < 1) {
    alert("Please enter a valid number of users.");
    return;
  }
  setAddingStreamId(stream._id);
  try {
    if (!stream.channelName) {
      alert("This stream does not have a channel name.");
      setAddingStreamId(null);
      return;
    }
    await ApiService.addUsersToStream({
      channelName: stream.channelName,
      userCount: Number(addCount),
    });
    alert(`Added ${addCount} users to the stream!`);
  } catch (e) {
    console.error("Failed to add users:", e);
    alert("Failed to add users.");
    fetchStreams();
  }
  setAddingStreamId(null);
};

  return (
    <Box className="adminPortalContainer">
      <Typography variant="h4" className="adminHeader" gutterBottom>
        Livestreams
      </Typography>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="40vh">
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 3,
            overflowX: "auto",
            py: 2,
            width: "100%",
            maxWidth: "100vw",
          }}
        >
          {streams.length === 0 && (
            <Typography color="textSecondary" align="center" sx={{ width: "100%" }}>
              No livestreams found.
            </Typography>
          )}
          {streams.map((stream) => (
            <Card
              key={stream._id}
              sx={{
                minWidth: 300,
                maxWidth: 340,
                background: "#18181c",
                color: "#ffee20",
                borderRadius: 3,
                boxShadow: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
              }}
            >
              {stream.GIF?.filePath && (
                <CardMedia
                  component="img"
                  height="140"
                  image={stream.GIF.filePath}
                  alt={stream.title}
                  sx={{ objectFit: "cover" }}
                />
              )}
              <CardContent sx={{ flex: 1 }}>
                <Typography variant="h6" sx={{ color: "#ffee20", fontWeight: 700, mb: 1 }}>
                  {stream.title || "Untitled Stream"}
                </Typography>
                <Typography variant="body2" sx={{ color: "#fff", opacity: 0.8, mb: 1 }}>
                  Channel: {stream.channelName}
                </Typography>
                <Typography variant="body2" sx={{ color: "#fff", opacity: 0.8, mb: 1 }}>
                  Platform: {stream.platform || "Unknown"}
                </Typography>
                <Typography variant="body2" sx={{ color: "#fff", opacity: 0.8, mb: 1 }}>
                  Created: {stream.createdAt ? new Date(stream.createdAt).toLocaleString() : "N/A"}
                </Typography>
                <Typography variant="body2" sx={{ color: stream.isExplicit ? "#ff4e6a" : "#ffee20", mb: 1 }}>
                  {stream.isExplicit ? "Explicit" : "Clean"}
                </Typography>
                <Typography variant="caption" sx={{ color: "#ffee20", display: "block", mb: 0.5 }}>
                  Host: {stream.createdByDetails?.firstName} {stream.createdByDetails?.lastName}
                </Typography>
                <Typography variant="caption" sx={{ color: "#fff", opacity: 0.7, mb: 2 }}>
                  {stream.viewers || 0} viewers
                </Typography>
                <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                  <Button
                    variant="contained"
                    sx={{
                      background: "#ffee20",
                      color: "#18181c",
                      fontWeight: 700,
                      flex: 1,
                      "&:hover": { background: "#fff350" },
                    }}
                    onClick={() => handleJoin(stream)}
                  >
                    Join
                  </Button>
                  <Button
                    variant="outlined"
                    sx={{
                      borderColor: "#ffee20",
                      color: "#ffee20",
                      fontWeight: 700,
                      flex: 1,
                      "&:hover": { background: "#222", borderColor: "#fff350", color: "#fff350" },
                    }}
                    onClick={() => handleEnd(stream.channelName)}
                  >
                    End
                  </Button>
                </Box>
                <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                  <input
                    type="number"
                    min={1}
                    placeholder="Users to add"
                    value={addCount}
                    onChange={e => setAddCount(e.target.value)}
                    style={{
                      flex: 2,
                      padding: 8,
                      borderRadius: 4,
                      border: "1px solid #ffee20",
                      color: "#18181c",
                      background: "#fff",
                    }}
                  />
                  <Button
                    variant="contained"
                    sx={{
                      background: "#ffee20",
                      color: "#18181c",
                      fontWeight: 700,
                      flex: 1,
                      "&:hover": { background: "#fff350" },
                    }}
                    disabled={addingStreamId === stream._id}
                    onClick={() => handleAddUsers(stream)}                  >
                    {addingStreamId === stream._id ? <CircularProgress size={20} color="inherit" /> : "Add"}
                  </Button>
                </Box>
              </CardContent>
            </Card>
          ))}
        </Box>
      )}
    </Box>
  );
}